import { useEffect, useState } from "react";

/**
 * Full-screen loader shown briefly on initial mount, then fades out.
 * Pure CSS animation, no JS perf cost after fade-out.
 */
export function AppLoader() {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    // Wait one tick after mount so the page can render behind it
    const t1 = setTimeout(() => setHidden(true), 350);
    // Remove from DOM after fade transition
    const t2 = setTimeout(() => setRemoved(true), 1200);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (removed) return null;

  return (
    <div
      className={`app-loader ${hidden ? "is-hidden" : ""}`}
      aria-hidden="true"
    >
      <div className="app-loader-cube">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
